// dispatchers
import { gameDispatcher, slotDispatcher, userConfigDispatcher } from '@aceroll/core';

import { StateController, dispatcher, serverData } from "@aceroll/core";

class FeatureSpinStopController extends StateController {
    constructor() {
        super("feature.spin.stop");
        this.app = dispatcher.app;
    }

    async onStart() {
        this.slotMachine = dispatcher.app.layout.slotMachine;

        const { gameType } = gameDispatcher.state;
        const { symbols } = serverData.currentResponse;
        const { gridWonSymbols } = serverData.currentResponse.parsed;

        slotDispatcher.updateSymbols(symbols, gameType, gridWonSymbols);

        await this.slotMachine.stop();

        userConfigDispatcher.unsubscribeSlamStop();
        userConfigDispatcher.restoreMode();

        this.stop();
    }

    onStop() {

    }
}

export default FeatureSpinStopController;